export default __webpack_public_path__ + "static/media/Mocana.7cf0847e.png";